export const LOCAL_STORAGE_NAMES = {
  LANG: 'lang',
  TOKEN: 'token',
  POD_BACK_URL: 'POD_BACK_URL',
  POD_EDITOR_TYPE: 'POD_EDITOR_TYPE',
  POD_EDITOR_PARAMS: 'POD_EDITOR_PARAMS',
  POD_USER_EDITOR_TOKEN: 'POD_USER_EDITOR_TOKEN',
  ERROR: 'error',
  REFRESH_TOKEN: 'refresh-token',
  OPEN_POP: 'OPEN_POP',
};

export const getLocalStorage = (name: string): string | null => {
  if (!name) return null;

  return localStorage.getItem(name);
};

export const setLocalStorage = (name: string, value: any): void => {
  if (!name) return;
  if (value === undefined || value === null) return;

  localStorage.setItem(name, value);
};

export const removeLocalStorage = (name: string): void => {
  if (!name) return;

  localStorage.removeItem(name);
};
